import { cachedRequest } from 'apiClient';

const cachedValidateRequest = async (validate: () => Promise<any>, key: string) => {
  const result = await cachedRequest<{ error?: Error }>(async () => {
    try {
      await validate();
    } catch (e) {
      return {
        error: e,
      };
    }
    return {
      error: undefined,
    };
  }, key);

  if (result.error) {
    throw result.error;
  }

  return result;
};

export default cachedValidateRequest;
